import { SECOND_IN_MILLISECONDS } from '../../../constants';
import { isFunction } from '../../../util/object';

const DEFAULT_BACKOFF_START_TIME = SECOND_IN_MILLISECONDS;
export default class RetryBackoffPolicy {
  /** @member {number} */
  _backOffTime;

  /** @member {RETRY_BACKOFF_POLICY_TYPES} */
  _backoffPolicyFunction;

  static policyLinearBackoff(backOffStartTime = DEFAULT_BACKOFF_START_TIME) {
    const backoffPolicyFunction = (currBackOffTime) => {
      return currBackOffTime + SECOND_IN_MILLISECONDS;
    };
    return new RetryBackoffPolicy(backoffPolicyFunction, backOffStartTime);
  }

  static policyExponentialBackoff(
    backOffStartTime = DEFAULT_BACKOFF_START_TIME,
  ) {
    const backoffPolicyFunction = (currBackOffTime) => {
      return currBackOffTime * 2;
    };
    return new RetryBackoffPolicy(backoffPolicyFunction, backOffStartTime);
  }

  static policyNoBackoff(backOffTime = 0) {
    const backoffPolicyFunction = (currBackOffTime) => {
      return currBackOffTime;
    };
    return new RetryBackoffPolicy(backoffPolicyFunction, backOffTime);
  }

  getNextBackoffTime() {
    const currBackOffTime = this._backOffTime;
    this._backOffTime = this._backoffPolicyFunction(currBackOffTime);
    return currBackOffTime;
  }

  /**
   * @constructor Use static ceonvinience methods above to be sane
   * @param  {Function} backoffPolicyFunction Function called to calculate next backofftime, given the current backoff time
   * @param  {Number} backOffStartTime      Time in ms
   */
  constructor(
    backoffPolicyFunction,
    backOffStartTime = DEFAULT_BACKOFF_START_TIME,
  ) {
    if (!isFunction(backoffPolicyFunction)) {
      throw new Error('Policy type must be one of acceptable types');
    }
    this._backoffPolicyFunction = backoffPolicyFunction;
    this._backOffTime = backOffStartTime;
  }
}
